import { Component, Prop, VModel, Vue } from 'vue-property-decorator';

@Component<SupplierSizeTextInputOld>({})
export default class SupplierSizeTextInputOld extends Vue {

  // #region @VModel

  @VModel()
  protected internalValue!: string[];

  protected textValue = '';

  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Supplier Size' })
  protected label!: string;

  @Prop({ default: 'Size' })
  protected placeholder!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers

  protected onBlur(): void {
    this.addTextToInternalValue(this.textValue);

    this.textValue = '';
  }

  // #endregion

  // #region Helpers

  protected addTextToInternalValue(text: string): void {
    if (text === '' || this.internalValue.includes(text)) { return; }

    this.internalValue.push(text);
  }

  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
